export const DEFAULT_AVATAR = '../s/images/profile-default.jpg'

export default DEFAULT_AVATAR
